const suffix = ` | Kosta Boda`;
export default suffix;
